import FullNameField from '@/components/field/FullNameField'
import UserConsentList from '@/users/components/consent/UserConsentList'
import UserConsentHistory from '@/users/components/consent/UserConsentHistory'
import UserConsentExport from '@/users/components/consent/UserConsentExport'
import FieldsIdentity from '@/users/components/fields/identity'
import FieldsMarketing from '@/users/components/fields/marketing'
import FieldsStatus from '@/users/components/fields/status'
import { Box, Grid, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import {
    DeleteButton,
    Edit,
    required,
    SaveButton,
    Toolbar,
    useEditController,
    useNotify,
    TabbedForm,
    FormTab
} from 'react-admin'
import { User } from '@/types'

export default function UserEdit() {
    const { record, isLoading: loading } = useEditController<User>()

    useEffect(() => {
        if (record) {
            document.title = `${record.firstName} ${record.lastName} - Client`
        }
    }, [record])

    return (
        <Edit mutationMode="optimistic" title={<Title />}>
            <TabbedForm
                record={record}
                warnWhenUnsavedChanges
                noValidate
                toolbar={<FormToolbar />}
                sx={{
                    padding: {
                        md: '32px',
                        xs: '16px'
                    }
                }}
            >
                <FormTab label="Informations personnelles">
                    <Grid
                        container
                        spacing={5}
                    >
                        <Grid item xs={12} md={6} display="flex" flexDirection="column" gap={3}>
                            <FieldsStatus />
                            <FieldsIdentity />
                            <FieldsMarketing />
                        </Grid>
                    </Grid>
                </FormTab>

                <FormTab label="Consentements RGPD">
                    {record?.id && (
                        <UserConsentList userId={record.id} user={record} />
                    )}
                </FormTab>

                <FormTab label="Historique des consentements">
                    {record?.id && (
                        <UserConsentHistory userId={record.id} />
                    )}
                </FormTab>

                <FormTab label="Export / Suppression RGPD">
                    {record?.id && (
                        <UserConsentExport userId={record.id} user={record} />
                    )}
                </FormTab>
            </TabbedForm>
        </Edit>
    )
}

const req = [required()]

const Title = () => (
    <Box>
        <Typography variant="h5">
            Utilisateur Client
        </Typography>
        <FullNameField sx={{ fontSize: '1.2rem', fontWeight: 500 }} />
    </Box>
)

const FormToolbar = () => {
    const notify = useNotify()

    return (
        <Toolbar className="fixed-bottom" sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', gap: 2 }}>
                <SaveButton alwaysEnable className="save" label="Enregistrer et quitter" />
                <SaveButton 
                    alwaysEnable 
                    className="save" 
                    label="Enregistrer" 
                    type="button" 
                    variant="text"
                    mutationOptions={{
                        onSuccess: (data) => {
                            notify('Utilisateur mis à jour avec succès', {
                                type: 'info',
                                messageArgs: { smart_count: 1 }
                            })
                        }
                    }}
                />
            </Box>
            <DeleteButton 
                confirmTitle="Supprimer cet utilisateur"
                confirmContent="Cette action est irréversible et supprimera également tous les consentements associés."
            />
        </Toolbar>
    )
}
